// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div>
    <div v-if="isMobile" id="list-view">
      <v-container fluid grid-list-md style="!important padding: 0px;">
        <v-row wrap>
          <template v-for="(image, i) in displayImages">
            <v-col lg="4" md="6" cols="12" :key="i">
              <component
                :is="public ? 'div' : 'router-link'"
                v-bind="mobileCardBind(image)"
                @click="onMobileCardClick(i, image.id)"
              >
                <v-card id="card-container" height="100%">
                  <v-container fill-height>
                    <v-layout fill-height>
                      <v-flex xs5 fill-height>
                        <img :ref="'img' + i" v-bind:src="getMiniUrl(image)" v-on:load="rotateImage($refs['img' + i], (image.exif_data && image.exif_data.orientation ? image.exif_data.orientation.value : 1), true)">
                      </v-flex>
                    <v-flex xs7>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon>watch_later</v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>{{ image.timestamp | formatDate }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <div class="tag_container_mobile">
                        <v-chip small v-for="category in image.categories" :key="category.id" class="tag blue lighten-2">
                          <p class="tagp">
                            <a href="javascript:;"
                            @click.stop="onMobileCategoryClick(category)"
                            style="color: black">
                              {{ category.name }}
                            </a>
                          </p>
                        </v-chip>
                        <v-chip small v-for="(tag, j) in image.tags" :key="(10000 + i * 10000) + j" class="tag green lighten-2">
                          <p class="tagp">
                            <a
                            href="javascript:;"
                            @click.stop="onMobileTagClick(tag)"
                            style="color: black">
                              {{ tag }}
                            </a>
                          </p>
                        </v-chip>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </component>
            </v-col>
          </template>
        </v-row>
      </v-container>
    </div>
    <div id="grid-view" v-else style="margin: 0px;">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-progress-linear v-if="displayLoading" :indeterminate="true"></v-progress-linear>
          <v-flex flexbox v-for="(image, i) in displayImages" :key="image.id">
            <v-card hover tile v-bind:height="image_card_height" :style="`background-color:${backgroundColor}`">
              <div class="check_container">
                <v-btn icon @click="clickCheck(i)"><v-icon :style="checkStyle(image.selected)">check_circle</v-icon></v-btn>
              </div>
              <v-flex class="quick_actions">
                <div v-if="image.location.coordinates[0] != 0 && image.location.coordinates[1] != 0 && !public">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="openMaps(image.location)"><v-icon style="color:rgb(255,255,255,0.5);">gps_fixed</v-icon></v-btn>
                    </template>
                    <span>View Maps</span>
                  </v-tooltip>
                </div>
                <div v-if="image.annotation.trim() && !public" class="comment_container">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="getSelectedComment(image.annotation)"><v-icon style="color:rgb(255,255,255,0.5);">comment</v-icon></v-btn>
                    </template>
                    <span>View Comment</span>
                  </v-tooltip>
                </div>
              </v-flex>
              <div class="tag_container" @click="clickImage(i , image.id)">
                <!-- spacer chip so none appears under the checkbox -->
                <v-chip disabled cursor="pointer" style="background-color: rgba(0, 0, 0, 0.0);">&nbsp;</v-chip>
                <v-chip
                v-for="category in image.categories"
                :key="category.id"
                :class="` tag blue ${tagTheme} `"
                :disabled="selectionMode"
                @click.stop="clickCategory(i, category)"
                small
                :title="'Search: Category = ' + category.name"
                >
                  <p class="tagp">{{ category.name }}</p>
                </v-chip>
                <v-chip
                v-for="(tag, j) in image.tags"
                :key="(10000 + i * 10000) + j"
                :title="'Search: Tag = ' + tag"
                :class="` tag green ${tagTheme} `"
                :disabled="selectionMode"
                small
                @click.stop="clickTag(i, tag)">
                 <p class="tagp">{{ tag }}</p>
                </v-chip>
              </div>
              <img
                @click="clickImage(i , image.id)"
                class="image"
                :src="getMiniUrl(image)"
                :height="thumbnailHeight"
                :style="checkStyleBorder(image.selected)"
                :ref="'img' + i"
                v-on:load="rotateImage($refs['img' + i], (image.exif_data && image.exif_data.orientation ? image.exif_data.orientation.value : 1), true)"
              />
              <div
                id="image_tags_box"
                class="text-xs-right nowrapping"
                @click="clickImage(i , image.id)">
                {{ image.timestamp | formatDate }}
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-tooltip left v-if="(selectionMode || isQuery) && !public">
      <template v-slot:activator="{ on }">
        <v-btn @click="startEditDialog()" fab dark small class="green" id="smallButtonFab" style="bottom: 200px;" v-on="on">
          <v-icon>create</v-icon>
        </v-btn>
      </template>
      <span>Edit Images</span>
    </v-tooltip>

    <v-tooltip left v-if="(selectionMode || isQuery) && !public">
      <template v-slot:activator="{ on }">
        <v-fab-transition>
          <v-btn @click="startShareDialog()" fab dark small color="primary" id="smallButtonFab" style="bottom: 255px;" v-on="on">
            <v-icon>mdi-share-variant-outline</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
      <span>Share Collection</span>
    </v-tooltip>

    <v-tooltip left v-if="(selectionMode || isQuery) && !public">
      <template v-slot:activator="{ on }">
        <v-btn @click="startDeleteDialog()" fab dark small class="red" id="smallButtonFab" style="bottom: 145px;" v-on="on">
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
      <span>Delete Images</span>
    </v-tooltip>

    <v-menu offset-x left v-if="selectionMode || isQuery">
      <template v-slot:activator="{ on: menu }">
        <v-tooltip left>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn fab small dark class="blue" id="smallButtonFab" style="bottom: 90px;" v-on="{ ...tooltip, ...menu }">
              <v-icon>get_app</v-icon>
            </v-btn>
          </template>
          <span>Export Data Menu</span>
        </v-tooltip>
      </template>
      <v-list>
      <v-list-item @click="clickDownload()" v-if="selectionMode">
        <v-list-item-title>Download Individual Images</v-list-item-title>
      </v-list-item>
      <v-list-item @click="clickDownloadZip()">
        <v-list-item-title>Download Zipped Images</v-list-item-title>
      </v-list-item>
      <v-list-item @click="clickDownloadCSV()">
        <v-list-item-title>Download CSV Data</v-list-item-title>
      </v-list-item>
    </v-list>
    </v-menu>

    <v-btn v-if="selectionMode" @click="clickClear()" dark class="amber py-6 px-6 rounded-lg" id="buttonFab" v-on="on">
      <span>Clear selection</span><v-icon right>clear</v-icon>
    </v-btn>
    <v-btn v-if="!public && !selectionMode" dark class="green py-6 px-6 rounded-lg" @click.native="uploadClick" id="buttonFab" transition="scale-transition" v-on="on">
      <span v-if="progress === 0">Upload photo</span><v-icon right v-if="progress === 0">add</v-icon>
      <v-progress-circular v-else-if="progress === 100" indeterminate></v-progress-circular>
      <v-progress-circular v-else v-bind:value="progress">{{ progress }}</v-progress-circular>
    </v-btn>
    <!-- Photo Editing Drawer -->
    <v-navigation-drawer app right clipped persistent v-model="showEditDrawer" mobile-breakpoint="800">
      <v-container grid-list-xs v-if="editMode">
        <v-col cols="12">
          <v-row>
            <v-btn icon @click="clearEditModal">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-row>
          <v-row justify="center" class="mb-2">
            <p class="text-h6" style="color: #616161;">Add categories & tags</p>
            <p class="text-subtitle-1" style="color: #757575;">You are editing <b>{{ isQuery ? displayImages.length : selectedImages.length}}</b> image{{addS()}}</p>
          </v-row>
          <v-btn block color="success" dark @click="showEditDialog = true">Save<v-icon right dark>create</v-icon></v-btn>
          <v-autocomplete
            :items="getCategories"
            v-model="properties.categories"
            item-text="name"
            item-value="id"
            label="Categories"
            return-object
            hide-details
            chips
            deletable-chips
            :menu-props="{ maxWidth: 225, closeOnContentClick: true, closeOnClick: true }"
            multiple
            hide-selected>
          </v-autocomplete>
          <v-combobox
            multiple
            label="Tags"
            v-model="shareTags"
            :items="getTags"
            chips
            deletable-chips
            hide-details
            :menu-props="{ closeOnClick: true }">
          </v-combobox>
        </v-col>
      </v-container>
      <v-container v-else>
        <v-col cols="12">
          <v-row>
            <v-btn icon @click="clearShareDrawer">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-row>
          <transition name="slide-x-reverse-transition" mode="out-in">
            <div v-if="isShareCreate && shareCreateSuccess" key="share-success">
              <v-row justify="center" class="my-8">
                <p class="text-h6 text-center mb-0 px-2">
                  <b>{{ savedShareName }}</b><br> shared collection created
                </p>
              </v-row>
              <v-row>
                <v-btn block outlined class="mt-2" @click="copyShareUrl">
                  <v-icon left small>content_copy</v-icon>
                  Copy share URL
                </v-btn>
              </v-row>
              <v-row>
                <v-btn block outlined class="mt-2" @click="openSharePreview">
                  <v-icon left small>open_in_new</v-icon>
                  Preview
                </v-btn>
              </v-row>
              <v-row>
                <v-btn block color="success" class="mt-4" @click="finishShareCreateSuccess">
                  Done
                </v-btn>
              </v-row>
            </div>
            <div v-else key="share-form">
              <v-row class="my-10" justify="center">
                <v-btn-toggle v-model="isShareCreate" mandatory color="primary" dense small>
                  <v-btn :value="true" small>Create</v-btn>
                  <v-btn :value="false" small>Update</v-btn>
                </v-btn-toggle>
              </v-row>
              <template v-if="isShareCreate">
                <v-row>
                  <v-text-field
                    label="Shared Collection Name"
                    v-model="shareName"
                    :error-messages="shareName.trim() ? [] : ['A name is required']"
                  ></v-text-field>
                </v-row>
              </template>
              <template v-else>
                <v-row>
                  <v-autocomplete
                    label="Shared Collections"
                    v-model="selectedShare"
                    v-bind:items="getShares"
                    item-text="name"
                    item-value="id"
                    chips
                  ></v-autocomplete>
                </v-row>
              </template>
              <template v-if="isShareCreate || selectedShare">
                <v-row class="mt-8">
                  <v-autocomplete
                    label="Shared Categories"
                    v-model="shareCategoryIDs"
                    v-bind:items="getCategories"
                    item-text="name"
                    item-value="id"
                    @click:close="searchClearCateogry"
                    multiple
                    chips
                    deletable-chips
                    hide-details
                    :menu-props="{ maxWidth: 225, closeOnContentClick: true, closeOnClick: true }"
                  ></v-autocomplete>
                </v-row>
                <v-row>
                  <v-combobox
                    label="Shared Tags"
                    v-model="shareTags"
                    v-bind:items="getTags"
                    multiple
                    chips
                    deletable-chips
                    hide-details
                    :menu-props="{ closeOnClick: true }"
                  ></v-combobox>
                </v-row>
                <v-row class="mt-8" align="center" justify="center">
                  <v-col cols="12" class="d-flex align-center flex-wrap">
                    <v-tooltip top max-width="519">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-3"
                          v-bind="attrs"
                          v-on="on"
                          aria-label="How share filters combine"
                        >
                          <v-icon small color="grey darken-2">info_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ shareCombineModeHint }}</span>
                    </v-tooltip>
                    <v-btn-toggle v-model="shareCombineMode" mandatory dense color="primary">
                      <v-btn value="or" small>Any (OR)</v-btn>
                      <v-btn value="and" small>All (AND)</v-btn>
                    </v-btn-toggle>

                  </v-col>
                </v-row>
                <v-row>
                  <v-btn
                    @click="clickSaveShareDebounced()"
                    block
                    class="mt-8"
                    color="success"
                    :disabled="saveShareInProgress || (isShareCreate && !shareName.trim())"
                    :loading="saveShareInProgress"
                  >
                    {{ isShareCreate ? 'Create' : 'Save' }}
                  </v-btn>
                </v-row>
              </template>
              <template v-if="shareUrl && !isShareCreate">
                <v-row class="mt-8">
                  <v-btn @click="copyShareUrl" block outlined small>
                    <v-icon left small>content_copy</v-icon>
                    Copy URL
                  </v-btn>
                </v-row>
              </template>
            </div>
          </transition>
        </v-col>
      </v-container>
    </v-navigation-drawer>

    <v-dialog v-model="showDeleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <div class="headline">Confirm Delete</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete all the selected images?  <b>This action cannot be undone.</b></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDeleteDialog = false">Cancel</v-btn>
          <v-btn flat color="red" @click="deleteImagesIndividual()">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCommentDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <h4>Comment </h4>
        </v-card-title>
        <div class="h-line"></div>
        <v-card-text style="white-space:pre-wrap;">{{selectedComment}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showEditDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <div class="headline">Confirm Edit</div>
        </v-card-title>
        <v-card-text>Are you sure you want to edit <b>{{isQuery ? displayImages.length : selectedImages.length}}</b> selected image<span>{{addS()}}</span>? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showEditDialog = false">Cancel</v-btn>
          <v-btn flat color="green" @click="addPropsToImages()">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteQueryDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <div class="headline">Confirm Delete</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete all {{ getNumImages }} images that satisfy this query?<b>
          This action cannot be undone.</b> Type <b>Delete</b> below to delete the images.
          <v-text-field
          label="Delete"
          v-model="deleteText"
          :rules="[deleteTextRule]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDeleteQueryDialog = false
          deleteText=''">Cancel</v-btn>
          <v-btn flat color="red" @click="deleteImagesQuery()" :disabled="!canDeleteQuery">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <input id="file-input" type="file" style="display: none;" @change="uploadFile" />
    <error-snackbar v-model="errorText"></error-snackbar>
    <v-dialog v-model="downloading" width="500">
      <v-card>
        <v-card-title>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <div class="headline ml-3">Zipping & Downloading...</div>
        </v-card-title>
        <v-card-text>(Click anywhere to continue)</v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import {ENDPOINT} from '@/shared/constants'
  import {ImageRotatorMixin} from '../shared/mixins'
  import ApiRequests from '@/api/ApiRequests'
  import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'

  export default {
    components: {
      ErrorSnackbar
    },

    props: {
      public: {
        type: Boolean,
        default: false
      },
      shareId: {
        type: String,
        default: ''
      }
    },

    data () {
      return {
        publicImages: [],
        publicImagesLoading: false,
        downloading: false,
        showCommentDialog: false,
        selectedComment: '',
        deleteText: '',
        endpoint: ENDPOINT,
        errorText: '',
        progress: 0,
        showDeleteDialog: false,
        showEditDrawer: false,
        showEditDialog: false,
        showDeleteQueryDialog: false,
        showImageTags: true,
        showUploadFile: true,
        thumbnailHeight: '200px',
        properties: {},
        selectedShare: '',
        editMode: true,
        isShareCreate: true,
        shareName: '',
        shareUuid: '',
        shareCategoryIDs: [],
        shareTags: [],
        shareCombineMode: 'and',
        saveShareInProgress: false,
        saveShareDebounceTimeout: null,
        savedShareName: '',
        shareCreateSuccess: false

      }
    },

    mixins: [ImageRotatorMixin],

    computed: {
      ...mapGetters([
        'getShares',
        'getCategories',
        'getTags',
        'getImages',
        'getLoading',
        'getNumImages',
        'getQuery',
        'getQueryOutput',
        'isQuery'
      ]),

      getShareCategories: function () {
        return this.getQuery.categories.map(c => c.id)
      },

      displayImages: function () {
        this.setImages(this.public ? this.publicImages : this.getImages)
        return this.getImages
      },

      displayLoading: function () {
        return this.public ? this.publicImagesLoading : this.getLoading
      },

      canDeleteQuery: function () {
        return this.deleteText.toLowerCase() === 'delete'
      },

      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      backgroundColor: function () {
        if (this.$vuetify.theme.isDark) {
          return '#363636'
        } else {
          return 'white'
        }
      },

      tagTheme: function () {
        if (this.$vuetify.theme.isDark) {
          return 'darken-2'
        } else {
          return 'lighten-2'
        }
      },

      image_card_height: function () {
        if (this.showImageTags) {
          return 'auto'
        } else {
          return this.thumbnailHeight
        }
      },

      selectedImages: function () {
        var ids = []
        for (var i = 0; i < this.displayImages.length; i++) {
          if (this.displayImages[i].selected) {
            ids.push(this.displayImages[i])
          }
        }
        return ids
      },

      selectedImageIds: function () {
        return this.selectedImages.map(x => x.id)
      },

      selectionMode: function () {
        return this.selectedImages.length > 0
      },

      shareUrl: function () {
        if (this.shareUuid) {
          return window.location.origin + '/#/share/' + this.shareUuid
        }
        return ''
      },

      shareCombineModeHint: function () {
        if (this.shareCombineMode === 'or') {
          return 'This will add photos to the public collection that have ANY of the shared categories or tags.'
        }
        return 'This will add photos to the public collection that have ALL of the shared categories and tags.'
      }
    },

    created () {
      var query = {}
      Object.assign(query, this.$route.query)
      if (Object.keys(query).length > 0) {
        this.searchSetQuery(query)
      }

      if (this.public) {
        this.fetchPublicImages()
      } else {
        this.search()
        this.fetchShares()
      }
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('focus', this.handleFocus)
      window.addEventListener('resize', this.handleFocus)
    },

    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('focus', this.handleFocus)
      window.removeEventListener('resize', this.handleFocus)
    },

    watch: {

      getQueryOutput: function () {
        if (this.public) return
        this.search()
      },

      selectedShare: function () {
        if (!this.isShareCreate) {
          var share = this.getShares.find(s => s.id === this.selectedShare)
          if (share) {
            if (share.uuid) {
              this.shareUuid = share.uuid
            }
            this.shareCategoryIDs = share.categoryIDs ? share.categoryIDs.slice() : []
            this.shareTags = share.tags ? share.tags.slice() : []
            this.shareCombineMode = share.combineMode === 'or' ? 'or' : 'and'
            this.searchSetSharePreview({
              categoryIDs: this.shareCategoryIDs || [],
              tags: this.shareTags || []
            })
            this.checkOrPreview()
          }
        }
      },

      showEditDrawer: function (val) {
        if (this.editMode) return
        this.checkOrPreview()
      },

      isShareCreate: function (val) {
        this.shareCreateSuccess = false
        this.selectedShare = ''
        this.shareUuid = ''
        if (val) {
          if (this.isQuery && this.getQuery) {
            this.shareCombineMode = this.getQuery.or ? 'or' : 'and'
          } else {
            this.shareCombineMode = 'and'
          }
        }
        if (!val) {
          this.fetchShares()
        }
      },

      shareCategoryIDs: function (val) {
        if (val.every(id => this.getQuery.categories.map(c => c.id).includes(id)) && this.getQuery.categories.every(c => val.includes(c.id))) return

        if (!this.showEditDrawer || this.editMode) return
        this.searchSetSharePreview({
          categoryIDs: val || [],
          tags: this.shareTags || []
        })
        this.checkOrPreview()
      },

      'getQuery.categories': function (val) {
        this.shareCategoryIDs = val.map(c => c.id)
      },

      shareTags: function (val) {
        if (!this.showEditDrawer || this.editMode) return
        if (val.every(t => this.getQuery.tags.includes(t)) && this.getQuery.tags.every(t => val.includes(t))) return

        var tags = Array.isArray(val) ? val : (val ? [val] : [])
        this.searchSetSharePreview({
          categoryIDs: this.shareCategoryIDs || [],
          tags: tags
        })
        this.checkOrPreview()
      },

      'getQuery.tags': function (val) {
        this.shareTags = val.slice()
      },

      shareCombineMode: function () {
        if (!this.showEditDrawer || this.editMode) return
        this.checkOrPreview()
      }
    },

    methods: {
      ...mapActions([
        'fetchCategories',
        'fetchImages',
        'fetchShares',
        'incrementLimit'
      ]),

      ...mapMutations([
        'searchOr',
        'setImages',
        'searchCategory',
        'searchClear',
        'searchSetQuery',
        'searchSetSharePreview',
        'searchTag',
        'toggleImageSelected',
        'searchClearCateogry'
      ]),

      // add total images to left of cancel button
      // on save add modal - are you sure you want to add X ? IM sure/ cancel
      // convert initial modal to drawer (like metadata) with same save and X

      addPropsToImages: function () {
        let updatedImages

        if (this.selectedImages.length) {
          updatedImages = JSON.parse(JSON.stringify(this.selectedImages)) // for selection
        } else if (this.isQuery) {
          updatedImages = this.displayImages // for query
        }

        const proms = []

        for (let image of updatedImages) {
          if (this.properties.tags) {
            let uniqueSet = new Set([...image.tags, ...this.properties.tags])
            image.tags = [...uniqueSet]
          }
          if (this.properties.categories) {
            let uniqueSet = new Set([...image.categories, ...this.properties.categories])
            image.categories = [...uniqueSet]
          }
          proms.push(ApiRequests.putImageProperties(image.id, image))
        }

        Promise.all(proms).then(() => {
          this.fetchImagesGlobal()
          this.clearEditModal()
        }).catch(e => {
          console.log(e)
          this.errorText = 'Error editing images'
          this.clearEditModal()
        })
      },

      addS: function () {
        let res = ''
        if (this.selectionMode) {
          if (this.selectedImages.length > 1) {
            res = 's'
          }
        } else if (this.isQuery) {
          if (this.displayImages.length > 1) {
            res = 's'
          }
        }

        return res
      },

      checkOrPreview: function () {
        var n = this.shareTags.length + this.shareCategoryIDs.length
        if (n > 1 && this.shareCombineMode === 'or') {
          this.searchOr(true)
        } else {
          this.searchOr(false)
        }
      },

      clearEditModal: function () {
        this.properties.categories = []
        this.properties.tags = []
        this.showEditDrawer = false
        this.showEditDialog = false
      },

      clearShareDrawer: function () {
        this.showEditDrawer = false
        this.shareTags = []
        this.shareCategoryIDs = []
        this.shareCombineMode = 'and'
        this.isShareCreate = true
        this.shareCreateSuccess = false
        this.shareUuid = ''
        this.savedShareName = ''
        this.selectedShare = ''
      },

      getSelectedComment: function (comment) {
        this.showCommentDialog = true
        this.selectedComment = comment
      },

      getMiniUrl: function (image) {
        if (this.public) {
          return this.endpoint + 'public/share/' + this.shareId + '/' + image.id + '/mini'
        }
        return this.endpoint + 'images/' + image.id + '/mini'
      },

      openMaps: function (location) {
        window.open('https://www.google.com/maps/search/?api=1&query=' + location.coordinates[1] + ',' + location.coordinates[0])
      },

      clickCheck: function (index) {
        this.toggleImageSelected(index)
      },

      clickCategory: function (index, category) {
        if (this.public) return
        if (!this.selectionMode) {
          this.searchCategory(category)
        } else {
          this.toggleImageSelected(index)
        }
        this.shareCategoryIDs.push(category.id)
      },

      clickClear: function () {
        for (var i = 0; i < this.displayImages.length; i++) {
          if (this.displayImages[i].selected) {
            this.toggleImageSelected(i)
          }
        }
      },

      clickSelectAll: function () {
        for (var i = 0; i < this.displayImages.length; i++) {
          if (!this.displayImages[i].selected) {
            this.toggleImageSelected(i)
          }
        }
      },

      deleteImagesQuery: function () {
        ApiRequests.deleteImages(this.getQueryOutput).then(r => {
          this.searchClear()
          this.showDeleteQueryDialog = false
        }).catch(e => {
          console.log(e)
          this.errorText = 'Error deleting images'
          this.showDeleteQueryDialog = false
        })
        this.deleteText = ''
      },

      deleteImagesIndividual: function () {
        var proms = []
        for (var i = 0; i < this.selectedImages.length; i++) {
          proms.push(ApiRequests.deleteImage(this.selectedImages[i].id))
        }
        Promise.all(proms).then(() => {
          this.fetchImagesGlobal()
          this.showDeleteDialog = false
        }).catch(e => {
          console.log(e)
          this.errorText = 'Error deleting images'
          this.showDeleteDialog = false
        })
      },

      deleteTextRule: function (x) {
        if (this.canDeleteQuery) {
          return true
        }
        return 'Enter "Delete" to delete images.'
      },

      clickDownloadCSV: function () {
        var url = ''
        if (this.selectionMode) {
          url = ENDPOINT + 'images/' + this.selectedImageIds + '/csv'
        } else {
          url = ENDPOINT + 'images//csv?' + new URLSearchParams(this.getQueryOutput).toString()
        }

        var link = document.createElement('a')
        document.body.appendChild(link)
        link.setAttribute('href', url)
        link.setAttribute('download', '')
        link.click()
        link.remove()
        this.downloading = true
      },

      clickDownloadZip: function () {
        var url = ''
        if (this.selectionMode) {
          url = ENDPOINT + 'images/' + this.selectedImageIds + '/zip'
        } else {
          url = ENDPOINT + 'images//zip?' + new URLSearchParams(this.getQueryOutput).toString()
        }

        var link = document.createElement('a')
        document.body.appendChild(link)
        link.setAttribute('href', url)
        link.setAttribute('download', '')
        link.click()
        link.remove()
        this.downloading = true
      },

      clickDownload: function () {
        this.downloadNext(0)
      },

      clickSaveShareDebounced: function () {
        if (this.saveShareInProgress) return
        if (this.saveShareDebounceTimeout) {
          clearTimeout(this.saveShareDebounceTimeout)
        }
        var self = this
        this.saveShareDebounceTimeout = setTimeout(function () {
          self.saveShareDebounceTimeout = null
          self.clickSaveShare()
        }, 300)
      },

      copyShareUrl: function () {
        if (!this.shareUrl) return
        navigator.clipboard.writeText(this.shareUrl).then(() => {
          this.errorText = 'Share URL copied to clipboard'
        }).catch((e) => {
          console.error('Failed to copy share URL: ' + e)
          this.errorText = 'Failed to copy share URL: ' + e
        })
      },

      openSharePreview: function () {
        if (!this.shareUrl) return
        window.open(this.shareUrl, '_blank', 'noopener,noreferrer')
      },

      finishShareCreateSuccess: function () {
        this.shareCreateSuccess = false
        this.shareUuid = ''
        this.savedShareName = ''
        this.selectedShare = ''
      },

      clickSaveShare: function () {
        if (this.saveShareInProgress) return
        this.saveShareInProgress = true
        var tags = [...this.shareTags]
        if (this.isShareCreate) {
          var share = {
            name: this.shareName,
            categoryIDs: this.shareCategoryIDs || [],
            tags: tags,
            combineMode: this.shareCombineMode,
            photos: []
          }
          ApiRequests.postShare(share).then((response) => {
            this.selectedShare = response.data.id
            this.shareUuid = response.data.uuid || response.data.id
            this.savedShareName = response.data.name || this.shareName
            this.shareName = ''
            this.shareCreateSuccess = true
            this.fetchShares()
            this.errorText = 'Share created successfully'
          }).catch((e) => {
            console.log(e)
            this.errorText = 'Error creating share: ' + (e.response && e.response.data ? e.response.data.error : e)
          }).finally(() => {
            this.saveShareInProgress = false
          })
        } else {
          var tmpShare = this.getShares.find(s => s.id === this.selectedShare)
          if (!tmpShare) {
            this.saveShareInProgress = false
            return
          }
          tmpShare.categoryIDs = this.shareCategoryIDs || []
          tmpShare.tags = tags
          tmpShare.combineMode = this.shareCombineMode
          tmpShare.photos = tmpShare.photos || []

          ApiRequests.updateShare(tmpShare)
          .then(() => {
            this.isShareCreate = false
            this.errorText = 'Share updated successfully'
          }).catch((e) => {
            console.log(e)
            this.errorText = 'Error updating share: ' + (e.response && e.response.data ? e.response.data.error : e)
          }).finally(() => {
            this.saveShareInProgress = false
          })
        }
      },

      downloadNext: function (i) {
        if (i >= this.selectedImages.length) {
          return
        }
        var link = document.createElement('a')
        document.body.appendChild(link)
        console.log(this.public)
        if (this.public) {
          link.setAttribute('href', this.endpoint + 'public/share/' + this.shareId + '/' + this.selectedImages[i].id)
        } else {
          link.setAttribute('href', this.endpoint + 'images/' + this.selectedImages[i].id)
        }
        var ext = '.jpg'
        if (this.selectedImages[i].cloud_photos.length > 0) {
          if (this.selectedImages[i].cloud_photos[0].format && this.selectedImages[i].cloud_photos[0].format !== '') {
            ext = '.' + this.selectedImages[i].cloud_photos[0].format
          }
        }
        link.setAttribute('download', this.selectedImages[i].id + ext)
        link.click()
        link.parentNode.removeChild(link)
        link.remove()
        // timeout required for firefox and ie
        setTimeout(() => {
          this.downloadNext(i + 1)
        }, 100)
      },

      mobileCardBind: function (image) {
        if (this.public) {
          return { style: 'cursor: pointer;' }
        }
        return { to: { name: 'imageEdit', params: { id: image.id } } }
      },

      onMobileCardClick: function (index, id) {
        if (!this.public) return
        this.clickImage(index, id)
      },

      onMobileCategoryClick: function (category) {
        if (this.public) return
        this.searchCategory(category)
      },

      onMobileTagClick: function (tag) {
        if (this.public) return
        this.searchTag(tag)
      },

      clickImage: function (index, id) {
        if (this.public) {
          var url = this.endpoint + 'public/share/' + this.shareId + '/' + id
          window.open(url, '_blank', 'noopener,noreferrer')
          return
        }
        if (this.showCommentDialog) {
        } else if (!this.selectionMode) {
          this.$router.push({'name': 'imageEdit', 'params': { 'id': id }})
        } else {
          this.clickCheck(index)
        }
      },

      clickTag: function (index, tag) {
        if (this.public) return
        if (!this.selectionMode) {
          this.searchTag(tag)
        } else {
          this.toggleImageSelected(index)
        }
      },

      checkStyle: function (selected) {
        if (selected) {
          return 'color: rgb(25, 118, 210); background-color: rgba(200, 200, 230, 0.8); border-radius: 50%;'
        } else {
          return 'color: rgba(255, 255, 255, 0.5); background-color: rgba(100, 100, 100, 0.5); border-radius: 50%;'
        }
      },

      checkStyleBorder: function (selected) {
        if (selected) {
          return 'outline: 4px solid rgb(25, 118, 210); outline-offset: -3px;'
        } else {
          return ''
        }
      },

      handleScroll: function () {
        if (this.public) return
        if ((window.scrollY + window.innerHeight) >= (document.body.scrollHeight - 400)) {
          this.incrementLimit()
        }
      },

      handleFocus: function () {
        this.downloading = false
      },

      fetchImagesGlobal: function () {
        this.fetchImages()
        if ((window.scrollY + window.innerHeight) === document.body.scrollHeight) {
          this.incrementLimit()
        }
      },

      fetchPublicImages: function () {
        this.publicImagesLoading = true
        ApiRequests.getPublicShare(this.shareId)
          .then(response => {
            this.publicImages = Array.isArray(response.data) ? response.data : (response.data.images || [])
          })
          .catch(() => {
            this.publicImages = []
          })
          .finally(() => {
            this.publicImagesLoading = false
          })
      },

      search: function (query) {
        this.$router.push({name: 'images', query: this.getQueryOutput})
        this.fetchImagesGlobal()
      },

      startDeleteDialog: function () {
        if (this.selectionMode) {
          this.showDeleteDialog = true
        } else if (this.isQuery) {
          this.showDeleteQueryDialog = true
        }
      },

      startShareDialog: function () {
        if (this.selectionMode || this.isQuery) {
          this.showEditDrawer = true
          this.editMode = false
          if (this.isShareCreate && this.isQuery && this.getQuery) {
            this.shareCategoryIDs = (this.getQuery.categories || []).map(function (c) {
              return c.id
            })
            this.shareTags = (this.getQuery.tags || []).slice()
            this.shareCombineMode = this.getQuery.or ? 'or' : 'and'
          } else if (this.isShareCreate) {
            this.shareCategoryIDs = []
            this.shareTags = []
            this.shareCombineMode = 'and'
          }
          if (!this.isShareCreate && this.selectedShare && this.getShares) {
            var share = this.getShares.find((s) => String(s.id) === String(this.selectedShare))
            if (share) {
              this.shareCategoryIDs = share.categoryIDs ? share.categoryIDs.slice() : []
              this.shareTags = share.tags ? share.tags.slice() : []
              this.shareCombineMode = share.combineMode === 'or' ? 'or' : 'and'
            }
          }
          this.checkOrPreview()
        }
      },

      startEditDialog: function () {
        if (this.selectionMode || this.isQuery) {
          this.showEditDrawer = true
          this.editMode = true
        }
      },

      uploadFile: function (event) {
        var config = {
          onUploadProgress: (progressEvent) => {
            this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        }

        var files = event.target.files
        for (var i = 0; i < files.length; i++) {
          ApiRequests.createImage(files[i], config).then(response => {
            if ((response.data.location.coordinates[0] === 0) && ('geolocation' in navigator)) {
              navigator.geolocation.getCurrentPosition((x) => {
                var coords = [x.coords.longitude, x.coords.latitude]
                var data = response.data
                data.location = {coordinates: coords}
                ApiRequests.putImageProperties(response.data.id, data).then(response => {
                  this.$router.push({name: 'imageEdit', params: {id: response.data.id}, query: {fromUpload: true}})
                })
                .catch(e => {
                  console.log(e)
                  this.$router.push({name: 'imageEdit', params: {id: response.data.id}, query: {fromUpload: true}})
                })
              }, (e) => {
                console.log(e)
                this.$router.push({name: 'imageEdit', params: {id: response.data.id}, query: {fromUpload: true}})
              })
            } else {
              this.$router.push({name: 'imageEdit', params: {id: response.data.id}, query: {fromUpload: true}})
            }
          })
          .catch(e => {
            this.progress = 0
            this.errorText = 'Error uploading file'
            console.log(e)
          })
        }
      },

      uploadClick: function () {
        document.getElementById('file-input').click()
      }
    }
  }
</script>

<style scoped>
  .container {
    padding: 8px !important;
  }

  a {
    text-decoration: none;
    color: black;
  }

  #grid-view {
    color: #fff;
    text-align: right;
    margin: 8px;
  }

  #grid-view .flex {
    flex-grow: 0;
  }

  #grid-view .card {
    display: inline-block;
  }

  #list-view .card {
    min-width: 150px;
    min-height: 200px;
  }

  #list-view img {
    max-height: 100%;
    max-width: 100%;
    display: block;
    position: relative;
  }

  #card-container .container {
    padding: 6px;
  }

  #card-container .layout {
    margin: 0px;
  }

  #card-container .flex{
    padding: 0px;
  }

  #image_tags_box {
    margin-left: 8px;
    margin-right: 8px;
    margin-bottom: 4px;
  }

  #smallButtonFab {
    border-radius: 8px !important;
    padding: 24px !important;
    margin: 8px !important;
    position: relative;
    overflow: hidden;
    position: fixed;
    right: 28px;
    z-index: 4;
  }

  #buttonFab {
    position: relative;
    overflow: hidden;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 4;
  }

  .check_container {
    position:absolute;
    z-index:2;
  }

  .quick_actions {
    position:absolute;
    z-index:2;
    bottom:30px;
    left:0px;
  }

  .h-line {
    background-color:rgb(141, 141, 141);
    margin-left:auto;
    margin-right:auto;
    margin-bottom:7px;
    width:90%;
    height:1px;
  }


  .tag {
    max-width: calc(100% - 8px);
    margin:1px;
  }

  .v-chip__content {
    max-width: calc(100%);
  }

  .tagp {
    margin: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .tag_container {
    position:absolute;
    right:0px;
    bottom:30px;
    overflow-y: hidden;
    overflow-x: hidden;
    height: 200px;
    width: 100%;
    z-index:1;
  }

  .tag_container_mobile {
    margin: 4px;
  }

  .chip {
    margin: 0px 3px 6px 3px !important;
    font-size: 12px !important;
    height: 21px !important;
    opacity: .7;
  }

  .nowrapping {
    white-space: nowrap;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// ImageList.vue?36621f2a